import { FaCircleCheck } from "react-icons/fa6"
import { Icon, Spinner } from "@chakra-ui/react"
import { Button, PulsingDot } from "@/components"
import { ComplianceType, UploadedDocument } from "@/types"
import { isCompleted } from "../utils"

interface Props {
  type: ComplianceType
  isLoading: boolean
  currentComplianceType: ComplianceType | null
  complianceDocuments: UploadedDocument[]
  setCurrentComplianceType: (type: ComplianceType) => void
}

export const ComplianceTab = ({ type, isLoading, currentComplianceType, complianceDocuments, setCurrentComplianceType }: Props) => {
  return (
    <Button
      variant={ type === currentComplianceType ? "tabSelected" : "tabUnselected"}
      onClick={() => setCurrentComplianceType(type)}
    >
      {type}
      {
        isLoading ? <Spinner size="xs" /> : (
          isCompleted(type, complianceDocuments) ? <Icon as={FaCircleCheck} boxSize={4} color="green.500" /> : <PulsingDot animationCount={3} />
        )
      }
    </Button>
  )
}
